// NOTE: This is a mapping of country code to language code used for generating the alternate link. The language code is not always the same as the country code
const countryMapping: { [key: string]: string } = {
  jp: 'ja',
};
export default countryMapping;
